import { Component,OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantBillingReports } from '../../models/merchant-billing-models/merchant-billing-reports';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'merchant-view-billing.component',
  templateUrl: './merchant-view-billing.component.html',
  styleUrls: ['./merchant-view-billing.component.scss']
})
export class MerchantViewBillingComponent implements OnInit {

  public showCancel: boolean = false;
  public title: string = '';
  public message: string = '';
  public acceptButtonText: string = "Accept";
  public cancelButtonText: string = "Cancel";
  public merchantBillReports: MerchantBillingReports[] = [];
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  public dtElement: DataTableDirective;
  public merchantBillingId: string = '';
  public date: string = '';
  private searchEndpoint = `${environment.apiUrl}/api/MerchantBillingReports/GetByPageNumber`;
  constructor(
    private _httpClient: HttpClient,
    private modal: NgbActiveModal
  ) {}

  ngOnInit() {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: false,
      processing: true,
      columns: [
        { data: 'merchantName' }, { data: 'cardAcceptor' }, { data: 'terminalID' }, { data: 'serialNumber' }, { data: 'activationDate' },
        { data: 'isActive' }, { data: 'days' }, { data: 'dateStart' }, { data: 'dateEnd' }, { data: 'transaction' }, { data: 'value' }
      ]
    };

    this.fetchInitialData();
  }

  private fetchInitialData() {
    const initialParams = {
      draw: 1, start: 0, length: 1000,
      search: { value: '', regex: false }
    };
    const user = { merchantBillingId: this.merchantBillingId, date: this.date };

    this._httpClient.post<any>(this.searchEndpoint, {
      dataTable: JSON.stringify(initialParams),
      user: JSON.stringify(user)
    }).subscribe(resp => {

      this.merchantBillReports = resp.data.map((item: any) => {
        return {
          ...item,
          activationDate: this.formatToDateString(item.activationDate),
          dateStart: this.formatToDateString(item.dateStart),
          dateEnd: this.formatToDateString(item.dateEnd)
        };
      });

      this.dtOptions.data = this.merchantBillReports;

      if (this.dtElement && this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      } else {
        this.dtTrigger.next(null);
      }
    });
  }

  private formatToDateString(dateInput: any): string {
    if (!dateInput) return '';
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return dateInput;

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  }

  public close(result: boolean) {
    this.modal.close(result);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}

